<template>
  <section class="bg-white text-black py-20 fade-in-on-scroll" v-scroll-fade>
    <div class="max-w-4xl mx-auto px-6">
      <h2 class="text-3xl font-bold text-center mb-12">Frequently Asked Questions</h2>

      <!-- FAQ List with staggered fade -->
      <div v-stagger-fade>
        <div
          v-for="(faq, index) in displayedFaqs"
          :key="index"
          class="mb-4 border-b border-gray-300"
        >
          <button
            @click="toggle(index)"
            class="w-full text-left flex justify-between items-center py-4 focus:outline-none"
          >
            <span class="text-lg font-medium">{{ faq.question }}</span>
            <svg
              :class="{ 'rotate-180': openIndex === index }"
              class="w-5 h-5 transform transition-all duration-300 ease-in-out"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          <transition name="expand">
            <div v-if="openIndex === index" class="pb-4 text-gray-700">
              {{ faq.answer }}
            </div>
          </transition>
        </div>
      </div>

      <!-- Toggle button -->
      <div v-if="faqs.length > 3" class="text-center mt-6">
        <button
          @click="showAll = !showAll"
          class="text-sm font-medium text-sky-900 hover:underline focus:outline-none"
        >
          {{ showAll ? "Show Less" : "Show More" }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FAQ",
  data() {
    return {
      openIndex: null,
      showAll: false,
      faqs: [
        {
          question: "Is my strategy kept confidential?",
          answer:
            "Absolutely. Your ideas stay yours — I treat every project with full confidentiality and never reuse or share client logic. You're trusting me with your edge, and I take that seriously.",
        },
        {
          question: "Do you work with MT4 too?",
          answer:
            "Yes — MT5 is my main focus, but I can also build or convert systems to run on MetaTrader 4 if needed.",
        },
        {
          question: "Do you only build for Forex?",
          answer:
            "While Forex is my core focus, I can also automate strategies for other markets — as long as they run on MetaTrader 5.",
        },
        {
          question: "Can you convert TradingView strategies?",
          answer:
            "Yes. I specialize in clean Pine Script → MQL5 conversions while preserving your logic exactly.",
        },
        {
          question: "Do you trade yourself?",
          answer:
            "Absolutely. I'm a trader first — that’s why I understand what actually matters in automation.",
        },
        {
          question: "How long does a typical build take?",
          answer:
            "Depends on complexity, but most builds are delivered in under a week with constant progress updates.",
        },
        {
          question: "Do you offer revisions?",
          answer:
            "Yes — I always include a revision window to make sure your logic is dialed in and performing right.",
        },
      ],
    };
  },
  computed: {
    displayedFaqs() {
      return this.showAll ? this.faqs : this.faqs.slice(0, 3);
    },
  },
  methods: {
    toggle(index) {
      this.openIndex = this.openIndex === index ? null : index;
    },
  },
};
</script>

<style scoped>
/* Chevron rotation - now slower and more deliberate */
.rotate-180 {
  transform: rotate(180deg);
}
svg {
  transition: all 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55); /* Bouncy rotation */
}

/* Answer expansion - luxurious animation */
.expand-enter-active,
.expand-leave-active {
  transition: 
    opacity 0.5s ease-in-out,
    max-height 0.5s ease-in-out;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  max-height: 0;
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  max-height: 500px; /* Generous space for answers */
}


.expand-enter-active {
  transition-delay: 0.01s;
}

</style>